export const messages_page = () => {

    $("#messagesTable").DataTable({
        stateSave: false,
        order: [0, 'desc'],
    })

}